// extracted by mini-css-extract-plugin
export default {"serviceContact":"contact_serviceContact__Upxty"};